<main>
  <mars-hero />
  <mars-why-join />
  <mars-join-suppliers-network />
  <mars-how-it-works />
</main>
<mars-contact-us-form />
